// Facade for DOMPurify
import DOMPurify from 'dompurify';

export const xss = DOMPurify.sanitize;